import { useRouter, type NativeStackNavigationOptions } from "expo-router";
import { HeaderBackButton } from "expo-router/build/react-navigation";
import { useColorScheme } from "nativewind";
import { NAV_THEME } from "../../lib/theme";
import { TEST_IDS } from "../../testIdDefinition";

export function useStackHeader(): NativeStackNavigationOptions {
    const { colorScheme } = useColorScheme();
    const router = useRouter();
    const scheme = colorScheme ?? "light";

    return {
        headerStyle: {
            backgroundColor: NAV_THEME[scheme].colors.background,
        },
        headerTintColor: NAV_THEME[scheme].colors.text,
        headerTitleStyle: {
            fontFamily: "PlusJakartaSans_600SemiBold",
        },
        headerShadowVisible: false,
        // headerBackButtonDisplayMode: "minimal",
        headerLeft: (props) =>
            props.canGoBack ? (
                <HeaderBackButton
                    {...props}
                    label=""
                    onPress={() => router.back()}
                    testID={TEST_IDS[TEST_IDS.STACK_BACK_BUTTON]}
                />
            ) : null,
    };
}
